import { fetchBaseQuery } from "@reduxjs/toolkit/dist/query";


export function fetchBaseQueryWithPrepareHeaders(config) {
  return fetchBaseQuery({
    ...config,
    prepareHeaders: (headers, {getState}) => {
      const token = (getState() as any).user?.userToken;
      if (token) {
          headers.set('Authorization', `Bearer ${token}`)
      }
      if(!headers.get('Content-Type')) {
        headers.set('Content-Type', 'application/json');
      }
      if(!headers.get('Accept')) {
        headers.set('Accept', 'application/json');
      }
      return headers;
  },
  })
}
